"use client";
import React, { createContext, useContext, useTransition } from "react";
import { useRouter } from "next/navigation";

const NavigateContext = createContext<(url: string) => void>(() => {});
export const useArticleNavigate = () => useContext(NavigateContext);

interface ArticlePageWrapperProps {
  children: React.ReactNode;
  skeleton: React.ReactNode;
}

export default function ArticlePageWrapper({ children, skeleton }: ArticlePageWrapperProps) {
  const [isPending, startTransition] = useTransition();
  const router = useRouter();

  const navigate = (url: string) => {
    startTransition(() => {
      router.push(url);
    });
  };

  return (
    <NavigateContext.Provider value={navigate}>
      {isPending ? skeleton : children}
    </NavigateContext.Provider>
  );
}
